<section class="refund-info">
    <h3 class="refund-info__heading">Refund Information</h3>
    <div class="refund-info-list">
        @for (refund of sortedRefunds; track refund.refundTransactionId) {
            <div>
                <div class="refund-info__grid refund-info__grid--2col">
                    <div>
                        <span class="refund-info__label"
                            >Refund Transaction ID</span
                        >
                        <p class="refund-info__value">
                            {{ refund.refundTransactionId }}
                        </p>
                    </div>
                    <div>
                        <span class="refund-info__label"
                            >Notification Type</span
                        >
                        <p class="refund-info__value">
                            {{ refund.refundNotificationType ?? "—" }}
                        </p>
                    </div>
                </div>
                <div class="refund-info__grid refund-info__grid--3col">
                    <div>
                        <span class="refund-info__label">Refund Date</span>
                        <p class="refund-info__value">
                            {{ refund.refundDate | date: "MM/dd/yyyy" }}
                        </p>
                    </div>
                    <div>
                        <span class="refund-info__label">Refund Amount</span>
                        <p class="refund-info__value">
                            {{ refund.refundAmount | negativeCurrency }}
                        </p>
                    </div>
                    <div>
                        <span class="refund-info__label">Refund by</span>
                        <p class="refund-info__value">
                            {{ refund.refundBy ?? "—" }}
                        </p>
                    </div>
                </div>
            </div>
        }
    </div>
</section>
